// extracted by mini-css-extract-plugin
export default {"wrapper":"menuAddSearchList_wrapper__y4QXq"};